import type { RouteObject } from 'react-router';

import { LOGIN_PATH, PIN_CHANGE_PATH } from '../../app/config';

/**
 * The two screens that live outside the shell.
 *
 * `/login` is public. `/pin` is authenticated but sits *outside*
 * `RequirePinChanged` — it is the one screen a worker with `mustChangePin` is
 * allowed to reach, and the router places it accordingly.
 */
export const publicAuthRoutes: RouteObject[] = [
  {
    path: LOGIN_PATH,
    lazy: async () => ({ Component: (await import('./LoginPage')).LoginPage }),
  },
];

export const pinChangeRoute: RouteObject = {
  path: PIN_CHANGE_PATH,
  lazy: async () => ({ Component: (await import('./PinChangePage')).PinChangePage }),
};
